import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import Summarydetails from "../Summarydetails";
import { getAdminPackageDetailsListing } from "../../axios";
import moment from "moment";
import BookingPageSkeleton from "../../../BookingPageSkeleton";
import ItineraryComponent from "./ItineraryComponent";
import { useSelector } from "react-redux";
import {
  addDaysToDate,
  constant,
  displayDateFormat,
  generateDateRange,
  getDateDifference,
} from "./commonFunction";
import ImageGalleryComponent from "./HotelDetailsComponent/ImageGalleryComponent";

const PackageShowcase = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const checkin = urlParams.get("checkin");
  const itineraryPlan = urlParams.get("itineraryPlan");
  const package_id = urlParams.get("package_id");

  const [tabValue, setTabValue] = useState("1");
  const [summaryTabData, setSummaryTabData] = useState([]);
  const [packageName, setPackageName] = useState("");
  const [packageImage, setPackageImage] = useState("");
  const [packageData, setPackageData] = useState([]);
  const [DatesOfDay, setDatesOfDay] = useState([]);
  const [totalDays, setTotalDays] = useState("");
  const [itineraryDetails, setItineraryDetails] = useState([]);
  const [skeleton, setSkeleton] = useState(true);

  const customerPackage = useSelector(
    (state) => state.adminPackageCart.customerPackage
  );

  const totalImages = [
    packageImage,
    ...customerPackage
      .map(({ child }) =>
        child
          .filter((x) => x.selected)
          .map(({ gallery }) => gallery)
          .flat(1)
      )
      .flat(1),
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [getAdminPackageDetailsListingData] = await Promise.all([
          getAdminPackageDetailsListing(package_id),
        ]);

        if (getAdminPackageDetailsListingData) {
          setPackageName(getAdminPackageDetailsListingData?.package_name);
          setPackageImage(getAdminPackageDetailsListingData?.package_image);

          const numberOfNights = parseInt(
            getAdminPackageDetailsListingData?.no_days
          );
          setTotalDays(numberOfNights);

          const datesToRender = generateDateRange(
            getAdminPackageDetailsListingData.start_date,
            numberOfNights
          );
          setDatesOfDay(datesToRender);

          // const itineraryPlan = getAdminPackageDetailsListingData.itinerary_data[0].children.map(
          //   (item) => ({
          //     ...item,
          //     range: item.range.map((r) => {
          //       const findStartDateDiff = getDateDifference(
          //         getAdminPackageDetailsListingData.start_date,
          //         r.startDate
          //       );
          //       const startDate = addDaysToDate(
          //         datesToRender[0],
          //         findStartDateDiff
          //       );

          //       const findDaysDiff = getDateDifference(r.startDate, r.endDate);
          //       const endDate = addDaysToDate(startDate, findDaysDiff);

          //       return {
          //         ...r,
          //         startDate: startDate,
          //         endDate: endDate,
          //       };
          //     }),
          //   })
          // );
          // setItineraryDetails(itineraryPlan);

          JSON.parse(itineraryPlan).map((itemPlan) =>
            setItineraryDetails(itemPlan.children)
          );

          setPackageData(getAdminPackageDetailsListingData);

          if (getAdminPackageDetailsListingData?.summary) {
            const sortedData = getAdminPackageDetailsListingData?.summary
              ?.map((item, index) => ({ index, ...item }))
              ?.sort((a, b) => {
                const accodata = a.check_in
                  ? moment(a.check_in, "HH:mm a").toDate()
                  : null;
                const accodatb = b.check_in
                  ? moment(b.check_in, "HH:mm a").toDate()
                  : null;

                if (accodata === null && accodatb === null) {
                  return a.index - b.index;
                }
                if (accodata === null) return 1;
                if (accodatb === null) return -1;

                return accodata - accodatb;
              })
              ?.map(({ index, ...item }) => item);

            const resultSummaryData = [];
            datesToRender.length > 0 &&
              datesToRender.map((sequenceDate) => {
                resultSummaryData.push({
                  label: moment(sequenceDate).format("DD MMM Y"),

                  content: (
                    <div class="dayplan-wrapper" data-testid="day-plan-wrapper">
                      {Array.isArray(sortedData) &&
                        sortedData.length > 0 &&
                        sortedData.map((item, index) => {
                          let DataValue = "";
                          const findStartDateDiff = getDateDifference(
                            getAdminPackageDetailsListingData.start_date,
                            item.start_date
                          );
                          const startDate = addDaysToDate(
                            datesToRender[0],
                            findStartDateDiff
                          );
                          const dateSelected = new Date(startDate);

                          if (item.TYPE !== "accommodation") {
                            if (
                              moment(dateSelected).format("Y-MM-DD") ===
                              moment(sequenceDate).format("Y-MM-DD")
                            ) {
                              DataValue = (
                                <div className="dayRowContainer" key={index}>
                                  <div className="summaryDetailWrapper">
                                    <div className="summaryDetailContainer">
                                      <span className="font12 hotel-row-text-date-summary">
                                        <b>
                                          {item?.check_in
                                            ? item?.check_in
                                            : "Coordinated Timing"}
                                        </b>
                                      </span>
                                      <span className="font12">
                                        {item?.time ? (
                                          <>
                                            {item?.service_name}{" "}
                                            {item?.full_address}
                                          </>
                                        ) : (
                                          <>
                                            Coordinated Timing for{" "}
                                            <b>{item?.service_name}</b>{" "}
                                            {item?.full_address}: The supplier
                                            will contact you to organize.
                                          </>
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          } else {
                            const startDate = moment(item.start_date).format(
                              "Y-MM-DD"
                            );
                            const endDate = moment(item.end_date).format(
                              "Y-MM-DD"
                            );
                            const seqDate = moment(sequenceDate).format(
                              "Y-MM-DD"
                            );

                            if (startDate <= seqDate && endDate > seqDate) {
                              if (startDate === seqDate) {
                                DataValue = (
                                  <div className="dayRowContainer" key={index}>
                                    <div className="summaryDetailWrapper">
                                      <div className="summaryDetailContainer">
                                        <p className="font12 hotel-row-text-date-summary">
                                          <b>
                                            {moment(item.check_in, [
                                              "h:mm A",
                                            ]).format("hh A")}
                                          </b>
                                        </p>
                                        <span className="font12">
                                          Check-in to <b>{item.service_name}</b>{" "}
                                          {item.full_address}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            } else if (endDate === seqDate) {
                              DataValue = (
                                <div className="dayRowContainer" key={index}>
                                  <div className="summaryDetailWrapper">
                                    <div className="summaryDetailContainer">
                                      <p className="font12 hotel-row-text-date-summary">
                                        <b>
                                          {moment(item.check_out, [
                                            "h:mm A",
                                          ]).format("hh A")}
                                        </b>
                                      </p>
                                      <span className="font12">
                                        Check-out from{" "}
                                        <b>{item.service_name}</b>{" "}
                                        {item.full_address}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          }

                          return DataValue;
                        })}
                    </div>
                  ),
                });
              });
            setSummaryTabData(resultSummaryData);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setSkeleton(false);
      }
    };

    fetchData();
  }, []);

  let CancellationModalHS = (id, data) => {
    if (!data || data === "no_cancellationPolicy") return null;
    data = data[0];
    let DataNew = "";
    let Value = "";
    let EuroIcon = "";
    let PerIcon = "";
    return (
      <>
        {data.map((i, index) => {
          const date = new Date(checkin);
          date.setDate(date.getDate() - parseInt(i.day_before_arrival));

          DataNew = displayDateFormat(date);

          if (i.penalty == "No Penalty") {
            Value = 0;
            EuroIcon = "";
            PerIcon = "";
          } else if (i.penalty == "Full Amount") {
            Value = "";
            EuroIcon = "";
            PerIcon = "Full booking amount will be charged.";
          } else if (i.penalty == "Percentage") {
            Value = i.cancellation_value;
            EuroIcon = "";
            PerIcon = "% of booking amount will be charged.";
          } else if (i.penalty == "Nights") {
            Value = i.cancellation_value;
            EuroIcon = <span>{constant.currencySign}</span>;
            PerIcon = " amount will be charged.";
          } else if (i.penalty == "Fixed Amount") {
            Value = i.cancellation_value;
            EuroIcon = <span>{constant.currencySign}</span>;
            PerIcon = " amount will be charged.";
          }

          if (i.day_before_arrival == 1) {
            DataNew = "In case of no show";
          }

          if (id == i.rate_plan_id) {
            return (
              <div className="cncpolicyTbl__row">
                <div className="cncpolicyTbl__col">
                  {index == 0 ? "Before" : "After"} &#x202A;{DataNew}&#x202C;
                </div>
                <div className="cncpolicyTbl__col">
                  {/* Charge {Value}% of booking amount will be charged */}
                  {EuroIcon} {Value}
                  {PerIcon}
                </div>
              </div>
            );
          } else {
            return (
              <div className="cncpolicyTbl__row">
                <div className="cncpolicyTbl__col">
                  {index == 0 ? "Before" : "After"} &#x202A;{DataNew}&#x202C;
                </div>
                <div className="cncpolicyTbl__col">
                  {/* Charge {Value}% of booking amount will be charged */}
                  {EuroIcon} {Value}
                  {PerIcon}
                </div>
              </div>
            );
          }
        })}
      </>
    );
  };

  if (skeleton) return <BookingPageSkeleton />;

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 mb-3">
          <h2 className="fw-bold">{packageName}</h2>
          <div className="d-flex text-muted">
            <small className="border px-2 py-0 fw-bold rounded me-2">
              {`${parseInt(totalDays)}N/${parseInt(totalDays) + 1}D`}
            </small>
            <div className="fw-bold">
              {itineraryDetails.length > 0 &&
                itineraryDetails.map(({ name, Location }, index) => (
                  <React.Fragment key={index}>
                    {`${name}N ${Location?.label || ""}`}
                    {index < itineraryDetails.length - 1 && (
                      <span className="black-dot"></span>
                    )}
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
      </div>
      <ImageGalleryComponent totalImages={totalImages} />
      <div className="row">
        <TabContext value={tabValue}>
          <div className="col-md-12">
            <TabList onChange={(_, value) => setTabValue(value)}>
              <Tab className="fw-bold" label="Package" value="1" />
              <Tab className="fw-bold" label="Description" value="4" />
              <Tab className="fw-bold" label="Policies" value="2" />
              <Tab className="fw-bold" label="Summary" value="3" />
            </TabList>
          </div>
          <div className="col-md-12" style={{ minHeight: "50vh" }}>
            <TabPanel className="px-0" value="1">
              <ItineraryComponent
                DatesOfDay={DatesOfDay}
                packageData={packageData}
                itineraryDetails={itineraryDetails}
              />
            </TabPanel>
            <TabPanel value="4">
              <div
                dangerouslySetInnerHTML={{
                  __html: packageData.package_description,
                }}
              />
            </TabPanel>
            <TabPanel className="px-0" value="2">
              <div className="cncpolicyTbl">
                <div className="cncpolicyTbl__head">
                  <div className="cncpolicyTbl__col">DATE</div>
                  <div className="cncpolicyTbl__col">FEE</div>
                </div>

                {CancellationModalHS(
                  packageData.id,
                  packageData?.cancellation?.cancellation_policy
                )}
              </div>
            </TabPanel>
            <TabPanel className="p-0" value="3">
              <Summarydetails summaryTabData={summaryTabData} />
            </TabPanel>
          </div>
        </TabContext>
      </div>
    </div>
  );
};

export default PackageShowcase;
